import React, { useState } from 'react';
import { Stack } from 'react-bootstrap';
import TopStories from 'components/TopStories';
import CreatePost from 'components/CreatePost';
import ForYouFeedList from 'components/SocialPost/ForYouFeedList';
import FollowingFeedList from 'components/SocialPost/FollowingFeedList';
import useTranslate from 'hooks/useTranslate';
import '../styles.scss';
import '../feed-tabs.scss';

type FeedTab = 'forYou' | 'following';

const SocialFeedPosts: React.FC = () => {
	const { translate } = useTranslate();
	const [activeTab, setActiveTab] = useState<FeedTab>('forYou');

	return (
		<div className="social-feed">
			<div className="social-feed-left">
				<Stack className="social-feed-posts">
					<TopStories />
					<CreatePost />

					{/* Sticky Tab Filter */}
					<div className="feed-tab-sticky-wrapper">
						<div className="feed-tab-switcher">
							<button
								className={`feed-tab-btn ${activeTab === 'forYou' ? 'active' : ''}`}
								onClick={() => setActiveTab('forYou')}
							>
								<span className="feed-tab-label">{translate('Common.forYouFeed')}</span>
								<span className="feed-tab-indicator" />
							</button>
							<button
								className={`feed-tab-btn ${activeTab === 'following' ? 'active' : ''}`}
								onClick={() => setActiveTab('following')}
							>
								<span className="feed-tab-label">{translate('Common.followingFeed')}</span>
								<span className="feed-tab-indicator" />
							</button>
						</div>
					</div>

					{/* Separate FlatList per tab - both stay mounted to preserve scroll */}
					<div style={{ display: activeTab === 'forYou' ? 'block' : 'none' }}>
						<ForYouFeedList />
					</div>
					<div style={{ display: activeTab === 'following' ? 'block' : 'none' }}>
						<FollowingFeedList />
					</div>
				</Stack>
			</div>
		</div>
	);
};

export default SocialFeedPosts;